import _objectSpread from "/codebuild/output/src1081057209/src/api-desk/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
//import _ from 'lodash'  // does not work in browser
// FUTURE FIX: https://2ality.com/2017/01/import-operator.html
var _lodash = null; // HACK: lodash loader...

if (typeof _ === 'undefined') {
  import('lodash').then(function (ld) {
    _lodash = ld;
  });
}

import { convert_profile_extra, generate_format_as_feed_options, generate_image_sizes, convert_profile_query_ored_tag_regexps } from './convert.js';
import { get_alignments_from_au } from './fdef_utils.js';
import { all_the_same, simple_deep_equal, random_id, validate_str, validate_start_and_end_date } from './utils.js';
export function generate_feeds_from_definition(_ref) {
  var feed_definitions = _ref.feed_definitions,
      feeds_before = _ref.feeds_before;

  /**
  * Generates feeds_after from feed_definitions and feeds_before
  * returns new alignments and feeds_after
  */
  if (!feed_definitions.feed_definitions || feed_definitions.feed_definitions.length != 1) {
    console.error('wrong format (must contain exactly one feed_definitions');
    return null;
  }

  var fdef = feed_definitions.feed_definitions[0];
  var alignments = get_alignments_from_au({
    au: feeds_before
  });
  var feeds_after = {
    feeds: [],
    profiles: [],
    apis: [],
    viewspecs: [],
    feed_definitions: []
  }; // find or create on profile per fdef

  var profile = find_existing_profile({
    feeds_before: feeds_before
  }) || create_profile();
  profile['nickname'] = validate_str(fdef.nickname) || 'default';
  profile['query_ored_tag_regexps'] = convert_profile_query_ored_tag_regexps(fdef.profile || []);
  profile['query_extra'] = convert_profile_extra(fdef.extra || []); // TODO error if no ored_regexp and no extra 

  feeds_after['profiles'].push(profile); // validate valid_from/valid_to

  var result = validate_start_and_end_date({
    start: fdef.valid_from,
    end: fdef.valid_to
  });
  var valid_from = result ? result.start : '';
  var valid_to = result ? result.end : ''; // generate one feed for each api

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (fdef.api || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var api = _step.value;

      var _feed = find_existing_feed({
        api: api,
        profile: profile,
        alignments: alignments,
        feeds_before: feeds_before
      }) || create_feed({
        api: api,
        profile: profile
      });

      var viewspec = find_existing_viewspec({
        for_internal_apikp_use_only: false,
        alignments: alignments,
        feeds_before: feeds_before
      }) || create_viewspec({
        for_internal_apikp_use_only: false
      });
      _feed = _objectSpread({}, _feed, {
        viewspec_id: viewspec.id,
        valid_from: valid_from,
        valid_to: valid_to,
        nickname: profile.nickname,
        sales_description: fdef.sales_description,
        api_id: "api-" + api.api_kind,
        // HACK: guess api_id
        for_internal_apikp_use_only: null
      });

      if (fdef.format && fdef.format.length > 0) {
        viewspec['feed_options'] = _objectSpread({}, viewspec.feed_options, generate_format_as_feed_options(fdef.format));
      }

      if (fdef.image && fdef.image.length > 0) {
        viewspec['media_group_contents_options'] = _objectSpread({}, viewspec.media_group_contents_options, {
          image_sizes: generate_image_sizes(fdef.image)
        });
      } else {
        viewspec['media_group_contents_options'] = null;
      }

      feeds_after['feeds'].push(_feed);
      feeds_after['viewspecs'].push(viewspec);
      feeds_after['apis'].push({
        id: _feed.api_id,
        kind: api.api_kind,
        for_internal_apikp_use_only: null
      }); // update alignments

      alignments.push({
        feed_id: _feed.id,
        api_kind: api.api_kind
      });
    } // dedupe viewspecs if all are equal

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (all_the_same(feeds_after['viewspecs'].map(function (vs) {
    return _objectSpread({}, vs, {
      id: null
    });
  }), {
    cmp: simple_deep_equal
  })) {
    var single_viewspec = feeds_after['viewspecs'][0];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = feeds_after['feeds'][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var feed = _step2.value;
        feed['viewspec_id'] = single_viewspec.id;
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    feeds_after['viewspecs'] = [single_viewspec];
  } // Add internal feed and api again
  // TODO: create internal api feed for brand new profile


  if (feeds_before) {
    // Add viewspec for_internal_apikp_use_only
    var internal_vs = find_existing_viewspec({
      for_internal_apikp_use_only: true,
      alignments: alignments,
      feeds_before: feeds_before
    });
    feeds_after['viewspecs'].push(internal_vs);
    var internal_feed = feeds_before.feeds.find(function (f) {
      return f.for_internal_apikp_use_only === true;
    });

    if (internal_feed) {
      internal_feed.nickname = '_internal';
      internal_feed.sales_description = fdef.sales_description;
      internal_feed.valid_from = valid_from;
      internal_feed.valid_to = valid_to;
      feeds_after['feeds'].push(internal_feed);
      var internal_api = feeds_before.apis.find(function (a) {
        return a.id === internal_feed.api_id;
      });
      feeds_after['apis'].push({
        id: internal_api.id,
        kind: internal_api.kind,
        for_internal_apikp_use_only: true
      });
    }
  } else {
    var _internal_api = {
      id: 'api-graphqlapikp',
      kind: 'graphqlapikp',
      for_internal_apikp_use_only: true // Add viewspec for_internal_apikp_use_only
      // TODO: find out if aufschaltung already has viewspec for internal_api

    };

    var _internal_vs = create_viewspec({
      for_internal_apikp_use_only: true
    });

    feeds_after['viewspecs'].push(_internal_vs);

    var _internal_feed = create_feed({
      api: _internal_api,
      profile: profile
    });

    _internal_feed.nickname = '_internal';
    _internal_feed.sales_description = fdef.sales_description;
    _internal_feed.valid_from = valid_from;
    _internal_feed.valid_to = valid_to;
    _internal_feed.viewspec_id = _internal_vs.id;
    _internal_feed.api_id = _internal_api.id;
    _internal_feed.api_kind = _internal_api.kind;
    _internal_feed.for_internal_apikp_use_only = true;
    feeds_after['feeds'].push(_internal_feed);
    feeds_after['apis'].push({
      id: _internal_api.id,
      kind: _internal_api.kind,
      for_internal_apikp_use_only: _internal_api.for_internal_apikp_use_only
    });
  } // Ensure unique api/feeds!
  // HACK: lodash loader...


  var uniq_feeds = _lodash ? _lodash.uniqBy(feeds_after['feeds'], 'id') : _.uniqBy(feeds_after['feeds'], 'id');
  feeds_after['feeds'] = uniq_feeds; // Ensure unique api_kinds!
  // HACK: lodash loader...

  var uniq_apis = _lodash ? _lodash.uniqBy(feeds_after['apis'], 'kind') : _.uniqBy(feeds_after['apis'], 'kind');
  feeds_after['apis'] = uniq_apis; // add originating feed definition with updated aligment info
  // TODO: update originated fdef!!!

  alignments = _lodash ? _lodash.uniqBy(alignments, 'feed_id') : _.uniqBy(alignments, 'feed_id');
  fdef.alignments = alignments;
  feeds_after['feed_definitions'] = [fdef];
  return {
    feeds_after: feeds_after,
    alignments: alignments
  };
}

function create_profile() {
  return {
    id: 'p-' + random_id(16),
    nickname: '',
    query_ored_tag_regexps: [],
    query_extra: ''
  };
}

function create_feed(_ref2) {
  var api = _ref2.api,
      profile = _ref2.profile;
  return {
    id: 'f-' + random_id(16),
    version: 1,
    profile_id: profile.id,
    nickname: profile.nickname,
    sales_description: '',
    api_kind: api.api_kind,
    is_activated: false,
    s3push_activated: false
  };
}

function create_vps(_ref3) {
  var api = _ref3.api;
  return {
    id: 'vp-' + random_id(16),
    feed_options: {
      ffmt: {
        jsonfeed: 'rubric'
      }[api.api_kind] || api.api_kind
    }
  };
}

function create_viewspec(_ref4) {
  var for_internal_apikp_use_only = _ref4.for_internal_apikp_use_only;

  if (for_internal_apikp_use_only) {
    return {
      id: 'vs-' + random_id(16),
      feed_options: {},
      content_options: null,
      media_group_contents_options: null,
      media_groups_options: null,
      category_options: null
    };
  }

  return {
    id: 'vs-' + random_id(16),
    feed_options: {
      required_format: "digitalwires",
      required_format_version: [">=0.0.1", "<2.0.0"]
    },
    content_options: null,
    media_group_contents_options: null,
    media_groups_options: null,
    category_options: null
  };
}

function find_existing_profile(_ref5) {
  var feeds_before = _ref5.feeds_before;

  if (!feeds_before) {
    return null;
  }

  var feeds = feeds_before.feeds || []; // pick profile_id from some feed if all are the same

  if (feeds.length > 0 && feeds[0].profile_id && all_the_same(feeds.map(function (f) {
    return f.profile_id;
  }), {})) {
    return {
      id: feeds[0].profile_id,
      nickname: feeds[0].nickname || '',
      query_ored_tag_regexps: [],
      query_extra: ''
    };
  } // TODO support both kinds (dynamo, cf3api)

}

function find_existing_feed(_ref6) {
  var api = _ref6.api,
      profile = _ref6.profile,
      alignments = _ref6.alignments,
      feeds_before = _ref6.feeds_before;

  if (!api || !api.api_kind) {
    return null;
  }

  if (!feeds_before) {
    return null;
  }

  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = (feeds_before.feeds || [])[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var feed = _step3.value;

      if (feed.api_kind === api.api_kind) {
        if (feed.profile_id === profile.id) {
          return feed;
        }
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return null;
}

function find_existing_dynamo_feed(_ref7) {
  var api = _ref7.api,
      profile = _ref7.profile,
      alignments = _ref7.alignments,
      feeds_before = _ref7.feeds_before;

  if (!api || !api.api_kind) {
    return null;
  }

  if (!feeds_before) {
    return null;
  }

  var feeds = feeds_before.feeds || [],
      vpss = feeds_before.view_parameterss || [];

  var vps_by_id = _relevant_vpss({
    vpss: vpss,
    feeds: feeds
  }).reduce(function (acc, vps) {
    acc[vps.id] = vps;
    return acc;
  }, {});

  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = feeds[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var feed = _step4.value;

      if (vps_by_id[feed.view_parameter_id] && vps_by_id[feed.view_parameter_id].api_kind === api.api_kind && feed.profile_id === profile.id) {
        return feed;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return null;
}

function find_existing_vps(_ref8) {
  var api = _ref8.api,
      alignments = _ref8.alignments,
      feeds_before = _ref8.feeds_before;

  if (!api || !api.api_kind) {
    return null;
  }

  if (!feeds_before) {
    return null;
  }

  var feeds = feeds_before.feeds || [],
      vpss = feeds_before.view_parameterss || [];
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = _relevant_vpss({
      vpss: vpss,
      feeds: feeds,
      add_default_view_options: false
    })[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var vps = _step5.value;

      if (vps.api_kind === api.api_kind) {
        return vps;
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return null;
}

function find_existing_viewspec(_ref9) {
  var for_internal_apikp_use_only = _ref9.for_internal_apikp_use_only,
      alignments = _ref9.alignments,
      feeds_before = _ref9.feeds_before;

  if (!feeds_before) {
    return null;
  }

  var viewspecs = feeds_before.viewspecs || [];
  var viewspec = viewspecs.find(function (vs) {
    var feed_options = vs.feed_options ? vs.feed_options : null;

    if (for_internal_apikp_use_only) {
      if (feed_options.required_format == undefined) return vs;
    } else {
      if (feed_options.required_format === 'digitalwires') return vs;
    }
  });
  return viewspec ? viewspec : null;
}